<template>
    <div class="table-container">
        <div class="title">
            <span>
                Active Hours List
            </span>
            <div>
                <v-btn class="edit-btn" @click="goToCreateActiveHour()">
                    Add Active Hour
                </v-btn>
            </div>
        </div>
        <array-view
            :items="activeHours"
            :headers="headers"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :is-fetching="isFetchingActiveHours"
            @paginationChange="paginationChange"
            @deleteActiveHour="deleteActiveHour"
        />
        <alert :show-alert="showAlert" :message="alertMessage" :type="alertType" />
    </div>
</template>

<script>
    import activeHoursService from '@/services/active-hours-service'
    import ArrayView from '@/components/ArrayView'
    import Alert from '@/components/Alert.vue'
    export default {
        components: { ArrayView, Alert },
        data() {
            return {
                headers: [
                    { text: 'Id', value: 'id' },
                    { text: 'Username', value: 'username' },
                    { text: 'Start Time', value: 'startTime' },
                    { text: 'End Time', value: 'endTime' },
                    { text: 'Enabled', value: 'enabled' },
                    { text: 'Actions', align: 'center', value: 'actions', sortable: false }
                ],
                activeHours: [],
                totalPages: 0,
                size: 5,
                page: 1,
                sortKey: 'id',
                sortOrder: 'ASC',
                isFetchingActiveHours: false,
                showAlert: false,
                alertMessage: '',
                alertType: ''
            }
        },
        watch: {
            page: 'applyFiltersToQuery',
            size: 'applyFiltersToQuery',
            sortKey: 'applyFiltersToQuery',
            sortOrder: 'applyFiltersToQuery'
        },
        created() {
            this.initializeFilters()
            this.fetchAllActiveHours()
        },
        methods: {
            paginationChange(page, size) {
                this.page = page
                this.size = size
                this.fetchAllActiveHours()
            },
            goToCreateActiveHour() {
                this.$router.push('/active-hours/create')
            },
            fetchAllActiveHours() {
                this.isFetchingActiveHours = true
                activeHoursService.getActiveHours(this.page, this.size, this.sortKey, this.sortOrder)
                    .then(resp => {
                        this.activeHours = resp.data.content || []
                        this.totalPages = resp.data.totalPages || 0
                    })
                    .catch((error) => {
                        this.setAlert(error.response.data.message, 'error')
                    })
                    .finally(() => {
                        this.isFetchingActiveHours = false
                    })
            },
            deleteActiveHour(id) {
                this.activeHours = this.activeHours.filter(activeHour => activeHour.id !== id)
            },
            setAlert(message, type) {
                this.alertMessage = message
                this.alertType = type
                this.showAlert = true
                setTimeout(() => { this.showAlert = false }, 3000)
            },
            initializeFilters() {
                const query = this.$route.query
                if (query.page) this.page = parseInt(query.page)
                if (query.pageSize) this.size = parseInt(query.pageSize)
                if (query.sortKey) this.sortKey = query.sortKey
                if (query.sortOrder) this.sortOrder = query.sortOrder
            },
            applyFiltersToQuery() {
                const query = {
                    page: this.page,
                    pageSize: this.size,
                    sortKey: this.sortKey,
                    sortOrder: this.sortOrder
                }
                this.$router.replace({ query })
            }
        }
    }
</script>

<style scoped>
.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.edit-btn {
    text-transform: none !important;
    background: #00acd6 !important;
    color: white;
    margin: 15px auto;
}
</style>
